export const linkPreferencesPath = '/manage-profile/link-preferences';
